import React, { FC, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, styled, useTheme } from "@mui/material";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./sidemenu";
import VersionUpdate from "../UI/VersionUpdate";
import { ModalProvider } from "../../contexts/ModalDialogContext";
import { DrawerProvider } from "../../contexts/DrawerContext";
import { TaskIndicatorProvider } from "../../contexts/TaskIndicatorContext";
import { ConsentProvider } from "../../contexts/ConsentBoxContext";
import RightSideBar from "./sidemenu/RightSideBar";

const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth: `calc(100%)`,
  marginLeft: "20%",
  marginRight: 0,
  paddingLeft: "1rem",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    paddingRight: "1rem",
  },
}));

const MainContentWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: 16,
}));

const StyledSideNavWrapper = styled(Box)(({ theme }) => ({
  width: "6%",
  background: "#fff",
  borderTopLeftRadius: 40,
  [theme.breakpoints.down("md")]: {
    position: "fixed",
    borderTopLeftRadius: 0,
    width: "100%",
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    marginTop: "auto",
    display: "flex",
    flexDirection: "row",
    zIndex: 1000,
    borderRadius: 0,
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  width: "93%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    paddingBottom: 70,
  },
}));

const RouterOutlet: any = Outlet;

const DashboardLayout: FC<any> = ({ children }) => {
  const theme = useTheme();
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  return (
    <>
      <DrawerProvider>
        <TaskIndicatorProvider>
          <ModalProvider>
            <ConsentProvider>
              <DashboardSidebar
                showMobileSideBar={showMobileSideBar}
                closeMobileSideBar={() => setShowMobileSideBar(false)}
              />
              <Wrapper>
                <DashboardNavbar
                  setShowMobileSideBar={() =>
                    setShowMobileSideBar((state) => !state)
                  }
                />
                <MainContentWrapper>
                  <ContentWrapper>
                    {children || <RouterOutlet />}
                  </ContentWrapper>
                  <StyledSideNavWrapper>
                    <RightSideBar />
                  </StyledSideNavWrapper>
                </MainContentWrapper>
              </Wrapper>
            </ConsentProvider>
          </ModalProvider>
          <VersionUpdate />
        </TaskIndicatorProvider>
      </DrawerProvider>
    </>
  );
};

export default DashboardLayout;
